var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9937 35.4271V3.69971H35.5232V35.4271H4.47053V3.69971H0V39.9997H40V35.4281L39.9937 35.4271Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3718 0H0V5H19V0H14.3718Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 0H19V5H32V0Z",
    fill: "#2650FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.32 2.49268L31.1621 5.65057L34.32 8.80847L37.4779 5.65057L34.32 2.49268Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H31V5H36V0Z",
    fill: "#2650FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9764 0H35.5059V4.46527H39.9764V0Z",
    fill: "#FFBB07"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.111 5.69775L27.9531 8.85565L31.111 12.0135L34.2689 8.85565L31.111 5.69775Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1168 8.68848L24.9589 11.8464L28.1168 15.0043L31.2747 11.8464L28.1168 8.68848Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9089 11.8926L21.751 15.0505L24.9089 18.2084L28.0668 15.0505L24.9089 11.8926Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 15.0967L18.5421 18.2546L21.7 21.4125L24.8579 18.2546L21.7 15.0967Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4919 18.3008L15.334 21.4587L18.4919 24.6166L21.6498 21.4587L18.4919 18.3008Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9764 4.27686H35.5059V8.74212H39.9764V4.27686Z",
    fill: "#FFBB07"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9764 8.54395H35.5059V13.0134H39.9764V8.54395Z",
    fill: "#FFBB07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.e8a2f53e68b082202d53973b48efee3c.svg";
export { ForwardRef as ReactComponent };